module.exports = __webpack_public_path__ + "img/fwwl_mobile_card.ce833ce5.png";